import { useState } from 'react'
import { navigate } from 'gatsby'
import clsx from 'clsx'
import { useBoolean } from 'ahooks'
import Layout from 'components/layouts/tow-column'
import { useLedgerItemCreateMutation } from 'lib/graphql/storeadmin'
import { ledgerItemErrorHandler } from 'lib/hooks/ledger'
import { Button, ErrorAlert, Form, SEO, showMessage } from 'components/common'
import { routes } from 'config'
import {
  SelectAndDescription,
  SelectAndDescriptionFormValues,
} from 'components/ledgers'

const onBack = () => navigate('../')

export const Head = () => <SEO title="項目の追加" />

const LedgerItemsNew = () => {
  const [requesting, setRequesting] = useBoolean(false)
  //  ledger error useState
  const [showLedgerErrorAlert, setShowLedgerErrorAlert] = useBoolean(false)
  const [ledgerErrorDescriptions, setLedgerErrorDescriptions] = useState<
    string[]
  >([])
  const [LedgerItemCreate, { loading, error }] = useLedgerItemCreateMutation()
  const [form] = Form.useForm<SelectAndDescriptionFormValues>()

  const onSubmit = async (values: SelectAndDescriptionFormValues) => {
    try {
      setRequesting.setTrue()
      const { data: result } = await LedgerItemCreate({
        variables: { inputs: values },
      })
      const { ledgerItemUserErrors } = result.ledgerItemCreate
      if (ledgerItemUserErrors?.length > 0) {
        const errorDescriptions = ledgerItemErrorHandler(ledgerItemUserErrors)
        setLedgerErrorDescriptions(errorDescriptions)
        setShowLedgerErrorAlert.setTrue()
        showMessage(
          'error',
          <>
            <div>項目の追加中にエラーが発生しました。</div>
            <div>{errorDescriptions.join('\n')}</div>
          </>
        )
      } else if (error) {
        throw error
      } else {
        setShowLedgerErrorAlert.setFalse()
        showMessage('success', '項目を追加ました。')
        await navigate(
          `${routes.ledgerItems}/${result?.ledgerItemCreate.ledgerItem?.id}`
        )
      }
    } catch (e) {
      console.error(e)
      const duplicateTitleError =
        e.message.search('Tried to save duplicate unique keys') > -1 &&
        '項目名が重複しています'
      showMessage(
        'error',
        <>
          <div>項目の追加時に予期せぬエラーが発生しました。</div>
          {duplicateTitleError && <div>{duplicateTitleError}</div>}
        </>
      )
      if (duplicateTitleError) {
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      }
    } finally {
      setRequesting.setFalse()
    }
  }

  return (
    <>
      <Form
        form={form}
        component="form"
        onFinish={onSubmit}
        name="LedgerItemsNew"
      >
        <Layout title="項目を追加する" onBack={onBack}>
          <Layout.Section size="large">
            <Layout.Item>
              {showLedgerErrorAlert && (
                <ErrorAlert
                  onCloseAlert={setShowLedgerErrorAlert.setFalse}
                  alertDescription={ledgerErrorDescriptions}
                />
              )}
              <SelectAndDescription
                maxTitleLength={64}
                maxDescriptionLength={256}
              />
            </Layout.Item>
          </Layout.Section>
          <Layout.Section size="small">
            {/* TODO: Comment out after api implementation */}
            {/* <Card>
              <div className={clsx('mb-8')}>分類</div>
            </Card> */}
          </Layout.Section>
          <Layout.Footer
            right={
              <div className={clsx('flex', 'justify-end')}>
                <Form.Item noStyle>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={requesting}
                    disabled={loading}
                  >
                    保存する
                  </Button>
                </Form.Item>
              </div>
            }
          />
        </Layout>
      </Form>
    </>
  )
}

export default LedgerItemsNew
